////
/// ============================================================================
/// COMPONENT / HMK / Main
/// ============================================================================
///
/// @group components
////

import {elemsGroups} from "svgo/plugins/_collections.js";

export default () => {

    window.$ = jQuery;

    class HmkCheckout {
			
			constructor(theBox) {
				
				this.es6Box = document.querySelector(theBox);
				
				this.es6Box.addEventListener('change', (event) => {
					if (event.target.matches('input[name^=payment_method]')) {
						this.updateCheckout();
					}
				});
				
				$(document.body).on('update_checkout', this.addSpinner);
				
				$(document.body).on('updated_checkout', this.removeSpinner);
				
			}
			
			updateCheckout() {
				setTimeout(function () {
					$(document.body).trigger('update_checkout');
				}, 250);
			}
			
			addSpinner() {
				$('.hmk_woocommerce-payment-shipping').block({
					message: null,
					overlayCSS: {
						background: '#fff',
						opacity: 0.6
					}
				});
			}
			
			removeSpinner() {

				let shipping = '';
				const shippingMethodContainer = document.getElementById('shipping_method');
				
				if (shippingMethodContainer) {
					const checkedMethod = shippingMethodContainer.querySelector('input.shipping_method:checked');
					if (checkedMethod) {
						const selectedShippingMethodContainer = checkedMethod.closest('li');
						if (selectedShippingMethodContainer) {
							const hiddenMethod = selectedShippingMethodContainer.querySelector('input.hmkShippingCode');
							if (hiddenMethod) {
								shipping = hiddenMethod.value;
							}
						}
					} else {
						const hiddenMethod = shippingMethodContainer.querySelector('input.hmkShippingCode');
						if (hiddenMethod) {
							shipping = hiddenMethod.value;
						}
					}
				}
				
				const skDelitimes = document.getElementById('sk-delitimes');
				const ymWar = document.getElementById('ym-war');
				const ymDiscl = document.getElementById('ym-discl');
				
				[skDelitimes, ymWar, ymDiscl].forEach((el) => {
					if (el) {
						el.classList.remove('show');
						el.classList.add('hide');
					}
				});
				
				switch (shipping) {
					case 'SK':
						if (skDelitimes) {
							skDelitimes.classList.remove('hide');
							skDelitimes.classList.add('show');
						}
						break;
					
					case 'YM':
						if (ymWar) {
							ymWar.classList.remove('hide');
							ymWar.classList.add('show');
						}
						if (ymDiscl) {
							ymDiscl.classList.remove('hide');
							ymDiscl.classList.add('show');
						}
						break;
					
				}
				
				$('.hmk_woocommerce-payment-shipping').unblock();
			}
			
    }
	
	class OrderTracking {
        
        constructor(theBox) {
            this.es6Box = document.querySelector(theBox);
            
            this.es6Box.addEventListener('click', (event) => {
                if (
                  event.target.matches('a.button.track') ||
                  event.target.matches('.js-hmk-track')
                ) {
                    this.popShipTracker(event);
                }
            });
        }
        
        popShipTracker(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const href = e.target.getAttribute('href');
            let shipMeth = '';
            
            if (href.includes('yamato')) {
                shipMeth = 'YM';
            } else if (href.includes('sagawa')) {
                shipMeth = 'SK';
            }
            
            switch (shipMeth) {
                case 'YM': {
                    const [url, tracker] = href.split('?');
                    
                    const form = document.createElement('form');
                    form.setAttribute('target', '_blank');
                    form.setAttribute('accept-charset', 'utf-8');
                    form.setAttribute('method', 'post');
                    form.setAttribute('action', url);
                    
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = 'number01';
                    input.value = tracker;
                    form.appendChild(input);
                    
                    document.body.appendChild(form);
                    form.submit();
                    document.body.removeChild(form);
                    break;
                }
                
                default:
                    window.open(href, '_blank', 'scrollbars=1,width=1000,height=1000');
            }
        }
        
    }
    
    class Zip2address {
        
        constructor(theBox) {
            this.es6Box = document.querySelector(theBox);
            
            this.es6Box.addEventListener('keyup', (event) => {
                // 1. Only proceed if the target is billing_postcode or shipping_postcode
                if (!event.target.matches('input#billing_postcode, input#shipping_postcode')) {
                    return; // early exit
                }
                
                // 2. Figure out if it's "billing" or "shipping" by splitting the ID
                const prefix = event.target.id.split('_')[0];  // "billing" or "shipping"
                
                // 3. Find the corresponding country <select> (e.g. #billing_country)
                const countrySelect = this.es6Box.querySelector(`#${prefix}_country`);
                
                // 4. Only call processZip if the country is JP
                if (countrySelect && countrySelect.value === 'JP') {
                    this.processZip(event);
                }
            });
        }
        
        
        processZip(e) {
            e.preventDefault();
            e.stopPropagation();
            
            const inputEl = e.target;
            
            const type = inputEl.id.split('_')[0];
            
            let zip = inputEl.value;
            const zipCount = zip.length;
            
            if (zipCount === 4 && zip.charAt(3) !== '-') {
                zip = zip.substring(0, 3) + '-' + zip.charAt(3);
                inputEl.value = zip;
            } else if (zipCount === 8 && zip.charAt(3) === '-') {
                this.queryYahoo(type, zip);
            }
            
            return true;
        }
        
        queryYahooJSONP(type, zip) {
            return new Promise((resolve, reject) => {
                const callbackName = 'jsonpCallback_' + Date.now();
                const params = new URLSearchParams({
                    appid: hmk_yahoo.key,
                    output: 'json',
                    query: zip,
                    callback: callbackName
                });
                
                const script = document.createElement('script');
                script.src = `${hmk_yahoo.url}?${params.toString()}`;
                
                window[callbackName] = (response) => {
                    delete window[callbackName];
                    document.body.removeChild(script);
                
                    if (response?.Feature?.[0]?.Property?.Address) {
                        this.displayAddress(type, response.Feature[0].Property.Address);
                    }
                    resolve(true);
                };
                
                script.onerror = () => {
                    delete window[callbackName];
                    document.body.removeChild(script);
                    reject(new Error('JSONP request failed'));
                };
                
                document.body.appendChild(script);
            });
        }
        
        async queryYahoo(type, zip) {
            try {
                const success = await this.queryYahooJSONP(type, zip);
                return success;
            } catch (err) {
                console.error(err);
                return false;
            }
        }
        
        displayAddress(type, address) {
            const states = hmk_yahoo.states;
            
            // We'll try a substring of length 3 first, then fallback to length 4
            let text_num = 3;
            let state = address.substr(0, text_num);
            
            // Look up state_id by finding the key whose value matches the `state` substring
            let state_id = Object.keys(states).find((key) => states[key] === state);
            
            // If not found, try a 4-character substring
            if (typeof state_id === 'undefined') {
                text_num = 4;
                state = address.substr(0, text_num);
                state_id = Object.keys(states).find((key) => states[key] === state);
            }
            
            // The remainder of `address` after the state substring is the city
            const city = address.substr(text_num);
            
            // Update the state field (e.g., "billing_state" or "shipping_state")
            const stateElem = document.getElementById(`${type}_state`);
            if (stateElem) {
                // First set it to the short state_id
                stateElem.value = state_id;
            }
            
            // Update the city field (e.g., "billing_city" or "shipping_city")
            const cityElem = document.getElementById(`${type}_city`);
            if (cityElem) {
                cityElem.value = city;
            }
            
            // Then overwrite the state field with "JP" + state_id
            // (mirroring the original jQuery code that called .val("JP" + state_id))
            if (stateElem) {
                stateElem.value = `JP${state_id}`;
            }
            
            // Finally, update the Select2 container text
            // (e.g., "select2-billing_state-container")
            const containerElem = document.getElementById(`select2-${type}_state-container`);
            if (containerElem && state_id) {
                containerElem.innerHTML = states[state_id];
            }
            
            return true;
        }
        
        
    }

    function onDomReady() {
        
        if (document.querySelector('form.checkout')) {
            const hmkCheckout = new HmkCheckout('form.checkout');
            const zip2address = new Zip2address('form.checkout');
        }
        
        if (document.querySelector('div.woocommerce-MyAccount-content div.woocommerce-address-fields')) {
            const zip2address = new Zip2address('div.woocommerce-address-fields');
        }

        if (document.querySelector('table.woocommerce-MyAccount-orders')) {
            const orderTracking = new OrderTracking('table.woocommerce-MyAccount-orders');
        }

        if (document.querySelector('#hmk-woocommerce-MyAccount-shipped-orders')) {
            const orderTracking = new OrderTracking('#hmk-woocommerce-MyAccount-shipped-orders');
        }

        if (document.querySelector('.js-hmk-tracking-data')) {
            const orderTracking = new OrderTracking('.js-hmk-tracking-data');
        }
        
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', onDomReady);
    } else {
        onDomReady();
    }
    
};
